import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { of } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { IFormSubmission } from 'shared';

import { DomService, FormSubmissionService } from '../../../services';
import { IconComponent } from '../../util/icon/icon.component';
import { BasePopupComponent, HorizontalAnchor, VerticalAnchor } from '../base-popup/base-popup.component';

@Component({
    selector: 'app-form-submitted-popup',
    templateUrl: './form-submitted-popup.component.html',
    styleUrls: ['./form-submitted-popup.component.scss'],
    imports: [IconComponent, TranslatePipe],
})
export class FormSubmittedPopupComponent extends BasePopupComponent<FormSubmittedPopupComponent> {
    private readonly formSubmissionService = inject(FormSubmissionService);

    public submissionId?: string;
    public submission?: IFormSubmission;

    public constructor() {
        super();
        this.verticalAnchor = VerticalAnchor.Center;
        this.horizontalAnchor = HorizontalAnchor.Center;
        this.popupOptions.padding = 0;
    }

    protected download(): void {
        const submission = this.submission
            ? of(this.submission)
            : this.formSubmissionService.getFormSubmission(this.submissionId);
        submission
            .pipe(
                take(1),
                tap((submission) => {
                    this.formSubmissionService.showFileSharePopup(submission);
                })
            )
            .subscribe();
    }

    public static show(domService: DomService, submission: string | IFormSubmission): void {
        domService.appendComponentTo<FormSubmittedPopupComponent>('overlay-container', FormSubmittedPopupComponent, {
            submissionId: typeof submission === 'string' ? submission : undefined,
            submission: typeof submission === 'object' ? submission : undefined,
        });
    }
}
